import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { CommissionActivityEntityType, CommissionActivityEventNode } from "./types";

export interface CommissionActivityEventsQueryResponse {
  commissionActivityEvents: {
    nodes: CommissionActivityEventNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export interface CommissionActivityEventsQueryVariables extends PaginationVariables {
  search?: string;
  entityType?: CommissionActivityEntityType;
  entityId?: string;
}

export const COMMISSION_ACTIVITY_EVENTS_QUERY: TypedDocumentNode<
  CommissionActivityEventsQueryResponse,
  CommissionActivityEventsQueryVariables
> = gql`
  query CommissionActivityEvents(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $search: String
    $entityType: BackofficeCommissionActivityEntityType
    $entityId: String
  ) {
    commissionActivityEvents(
      first: $first
      after: $after
      last: $last
      before: $before
      search: $search
      entityType: $entityType
      entityId: $entityId
    ) {
      nodes {
        id
        entityType
        entityId
        eventType
        description
        actorDisplayName
        occurredAt
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
